import { createReducer, on } from '@ngrx/store';
import { WifiProfileApiActions } from './wifi-profile.actions';
import { initialState, adapter } from './wifi-profile.state';

export const wifiProfilesReducer = createReducer(
  initialState,
  on(WifiProfileApiActions.profilesLoaded, (state, { profiles }) => adapter.upsertMany(profiles, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectWifiProfileIds = selectIds;
export const selectWifiProfileEntities = selectEntities;
export const selectAllWifiProfiles = selectAll;
